import * as mutationTypes from '@/store/modules/service/mutation-types'
import { SERVICE_BREAK_POST } from '@/store/modules/service/breaks/action-types'
import { putCircuitBreak } from '@/utils/api/agency/circuits'
import { getLocation } from '@/utils/io/geolocation'

export default {
  /**
   * Gestion des pauses
   * @param state
   * @param commit
   * @param rootGetters
   * @param {Object} breakInfos
   * @returns {Promise<void>}
   */
  [SERVICE_BREAK_POST]: async ({ state, commit, getters, rootGetters }, breakInfos) => {
    const { active } = state
    const { breaks } = getters
    const nextPause = getters.nextBreak || {}

    const { serviceStatus, pause, event } = await putCircuitBreak({
      circuit: active.id,
      break: {
        ...nextPause,
        ...breakInfos
      },
      event: {
        location: await getLocation()
      }
    })
    const newBreaks = [...breaks]
    const i = newBreaks.findIndex((b) => b.reference === pause.reference)
    if (i === -1) {
      newBreaks.push(pause)
    } else {
      newBreaks.splice(i, 1, pause)
    }
    commit(mutationTypes.SERVICE_SET_ACTIVE, {
      ...active,
      status: serviceStatus,
      breaks: newBreaks
    })
    commit(mutationTypes.SERVICE_SET_EVENT, { eventData: event })
  }
}
